import { get, post, del } from '@api/request';

export async function fetchRoles({ eventService }, authenticationToken) {
  const url = `${eventService}/events/roles`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function fetchFormAssocs(
  { eventService },
  authenticationToken,
  { roleID },
) {
  const url = `${eventService}/events/peventforms/role/${roleID}/formassocs`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function createFormAssoc(
  { eventService },
  authenticationToken,
  { roleID, data },
) {
  const url = `${eventService}/events/peventforms/role/${roleID}/formassocs`;
  const { body } = await post(authenticationToken, url, data);
  return body;
}

export async function deleteFormAssoc(
  { eventService },
  authenticationToken,
  { assocID },
) {
  const url = `${eventService}/events/formassoc/${assocID}`;
  const { body } = await del(authenticationToken, url);
  return body;
}

export async function deleteFormAssocs(
  { eventService },
  authenticationToken,
  { roleID },
) {
  const url = `${eventService}/events/peventforms/role/${roleID}/formassocs`;
  const { body } = await del(authenticationToken, url);
  return body;
}
